// Liste d'indicatifs pays (dial codes) pour le sélecteur PhoneInput.
// Ordonné : Sénégal en premier, puis Afrique de l'Ouest / Afrique / Europe / Reste du monde.
// Emoji drapeau + nom + code (ISO alpha-2) + indicatif téléphonique.

export const COUNTRY_CODES = [
  // Afrique de l'Ouest
  { code: "SN", name: "Sénégal", dial: "+221", flag: "🇸🇳" },
  { code: "CI", name: "Côte d'Ivoire", dial: "+225", flag: "🇨🇮" },
  { code: "ML", name: "Mali", dial: "+223", flag: "🇲🇱" },
  { code: "BF", name: "Burkina Faso", dial: "+226", flag: "🇧🇫" },
  { code: "NE", name: "Niger", dial: "+227", flag: "🇳🇪" },
  { code: "TG", name: "Togo", dial: "+228", flag: "🇹🇬" },
  { code: "BJ", name: "Bénin", dial: "+229", flag: "🇧🇯" },
  { code: "GN", name: "Guinée", dial: "+224", flag: "🇬🇳" },
  { code: "GW", name: "Guinée-Bissau", dial: "+245", flag: "🇬🇼" },
  { code: "GM", name: "Gambie", dial: "+220", flag: "🇬🇲" },
  { code: "MR", name: "Mauritanie", dial: "+222", flag: "🇲🇷" },
  { code: "CV", name: "Cap-Vert", dial: "+238", flag: "🇨🇻" },
  { code: "LR", name: "Liberia", dial: "+231", flag: "🇱🇷" },
  { code: "SL", name: "Sierra Leone", dial: "+232", flag: "🇸🇱" },
  { code: "GH", name: "Ghana", dial: "+233", flag: "🇬🇭" },
  { code: "NG", name: "Nigeria", dial: "+234", flag: "🇳🇬" },
  // Afrique centrale
  { code: "CM", name: "Cameroun", dial: "+237", flag: "🇨🇲" },
  { code: "GA", name: "Gabon", dial: "+241", flag: "🇬🇦" },
  { code: "CG", name: "Congo", dial: "+242", flag: "🇨🇬" },
  { code: "CD", name: "RD Congo", dial: "+243", flag: "🇨🇩" },
  { code: "TD", name: "Tchad", dial: "+235", flag: "🇹🇩" },
  { code: "CF", name: "Centrafrique", dial: "+236", flag: "🇨🇫" },
  { code: "GQ", name: "Guinée équatoriale", dial: "+240", flag: "🇬🇶" },
  // Afrique du Nord
  { code: "MA", name: "Maroc", dial: "+212", flag: "🇲🇦" },
  { code: "DZ", name: "Algérie", dial: "+213", flag: "🇩🇿" },
  { code: "TN", name: "Tunisie", dial: "+216", flag: "🇹🇳" },
  { code: "LY", name: "Libye", dial: "+218", flag: "🇱🇾" },
  { code: "EG", name: "Égypte", dial: "+20", flag: "🇪🇬" },
  // Afrique de l'Est/Sud
  { code: "ET", name: "Éthiopie", dial: "+251", flag: "🇪🇹" },
  { code: "KE", name: "Kenya", dial: "+254", flag: "🇰🇪" },
  { code: "TZ", name: "Tanzanie", dial: "+255", flag: "🇹🇿" },
  { code: "UG", name: "Ouganda", dial: "+256", flag: "🇺🇬" },
  { code: "RW", name: "Rwanda", dial: "+250", flag: "🇷🇼" },
  { code: "ZA", name: "Afrique du Sud", dial: "+27", flag: "🇿🇦" },
  { code: "MG", name: "Madagascar", dial: "+261", flag: "🇲🇬" },
  { code: "MU", name: "Maurice", dial: "+230", flag: "🇲🇺" },
  { code: "SC", name: "Seychelles", dial: "+248", flag: "🇸🇨" },
  { code: "KM", name: "Comores", dial: "+269", flag: "🇰🇲" },
  { code: "DJ", name: "Djibouti", dial: "+253", flag: "🇩🇯" },
  // Europe
  { code: "FR", name: "France", dial: "+33", flag: "🇫🇷" },
  { code: "BE", name: "Belgique", dial: "+32", flag: "🇧🇪" },
  { code: "CH", name: "Suisse", dial: "+41", flag: "🇨🇭" },
  { code: "LU", name: "Luxembourg", dial: "+352", flag: "🇱🇺" },
  { code: "GB", name: "Royaume-Uni", dial: "+44", flag: "🇬🇧" },
  { code: "IE", name: "Irlande", dial: "+353", flag: "🇮🇪" },
  { code: "DE", name: "Allemagne", dial: "+49", flag: "🇩🇪" },
  { code: "AT", name: "Autriche", dial: "+43", flag: "🇦🇹" },
  { code: "NL", name: "Pays-Bas", dial: "+31", flag: "🇳🇱" },
  { code: "IT", name: "Italie", dial: "+39", flag: "🇮🇹" },
  { code: "ES", name: "Espagne", dial: "+34", flag: "🇪🇸" },
  { code: "PT", name: "Portugal", dial: "+351", flag: "🇵🇹" },
  { code: "GR", name: "Grèce", dial: "+30", flag: "🇬🇷" },
  { code: "TR", name: "Turquie", dial: "+90", flag: "🇹🇷" },
  { code: "SE", name: "Suède", dial: "+46", flag: "🇸🇪" },
  { code: "NO", name: "Norvège", dial: "+47", flag: "🇳🇴" },
  { code: "DK", name: "Danemark", dial: "+45", flag: "🇩🇰" },
  { code: "FI", name: "Finlande", dial: "+358", flag: "🇫🇮" },
  { code: "PL", name: "Pologne", dial: "+48", flag: "🇵🇱" },
  { code: "RU", name: "Russie", dial: "+7", flag: "🇷🇺" },
  // Moyen-Orient
  { code: "SA", name: "Arabie saoudite", dial: "+966", flag: "🇸🇦" },
  { code: "AE", name: "Émirats arabes unis", dial: "+971", flag: "🇦🇪" },
  { code: "QA", name: "Qatar", dial: "+974", flag: "🇶🇦" },
  { code: "KW", name: "Koweït", dial: "+965", flag: "🇰🇼" },
  { code: "BH", name: "Bahreïn", dial: "+973", flag: "🇧🇭" },
  { code: "OM", name: "Oman", dial: "+968", flag: "🇴🇲" },
  { code: "JO", name: "Jordanie", dial: "+962", flag: "🇯🇴" },
  { code: "LB", name: "Liban", dial: "+961", flag: "🇱🇧" },
  { code: "IL", name: "Israël", dial: "+972", flag: "🇮🇱" },
  { code: "IR", name: "Iran", dial: "+98", flag: "🇮🇷" },
  { code: "IQ", name: "Irak", dial: "+964", flag: "🇮🇶" },
  // Amérique du Nord
  { code: "US", name: "États-Unis", dial: "+1", flag: "🇺🇸" },
  { code: "CA", name: "Canada", dial: "+1", flag: "🇨🇦" },
  { code: "MX", name: "Mexique", dial: "+52", flag: "🇲🇽" },
  // Amérique du Sud
  { code: "BR", name: "Brésil", dial: "+55", flag: "🇧🇷" },
  { code: "AR", name: "Argentine", dial: "+54", flag: "🇦🇷" },
  { code: "CL", name: "Chili", dial: "+56", flag: "🇨🇱" },
  { code: "CO", name: "Colombie", dial: "+57", flag: "🇨🇴" },
  { code: "PE", name: "Pérou", dial: "+51", flag: "🇵🇪" },
  { code: "VE", name: "Venezuela", dial: "+58", flag: "🇻🇪" },
  // Asie
  { code: "CN", name: "Chine", dial: "+86", flag: "🇨🇳" },
  { code: "JP", name: "Japon", dial: "+81", flag: "🇯🇵" },
  { code: "KR", name: "Corée du Sud", dial: "+82", flag: "🇰🇷" },
  { code: "IN", name: "Inde", dial: "+91", flag: "🇮🇳" },
  { code: "PK", name: "Pakistan", dial: "+92", flag: "🇵🇰" },
  { code: "BD", name: "Bangladesh", dial: "+880", flag: "🇧🇩" },
  { code: "ID", name: "Indonésie", dial: "+62", flag: "🇮🇩" },
  { code: "MY", name: "Malaisie", dial: "+60", flag: "🇲🇾" },
  { code: "TH", name: "Thaïlande", dial: "+66", flag: "🇹🇭" },
  { code: "VN", name: "Viêt Nam", dial: "+84", flag: "🇻🇳" },
  { code: "PH", name: "Philippines", dial: "+63", flag: "🇵🇭" },
  { code: "SG", name: "Singapour", dial: "+65", flag: "🇸🇬" },
  { code: "HK", name: "Hong Kong", dial: "+852", flag: "🇭🇰" },
  { code: "TW", name: "Taïwan", dial: "+886", flag: "🇹🇼" },
  // Océanie
  { code: "AU", name: "Australie", dial: "+61", flag: "🇦🇺" },
  { code: "NZ", name: "Nouvelle-Zélande", dial: "+64", flag: "🇳🇿" },
];

// Recherche l'entrée pays correspondant à un indicatif (le premier match).
export function findCountryByDial(dial) {
  if (!dial) return COUNTRY_CODES[0];
  return COUNTRY_CODES.find((c) => c.dial === dial) || COUNTRY_CODES[0];
}
